/**
 * Responsavel por desenhar os markers na tela de historico de posicao
 * Created by fabio jr. on 20/10/14.
 */


Greenmile.TrackEquipment = Greenmile.TrackEquipment || {};

Greenmile.TrackEquipment.EventEquipment = function (map) {

    this.requestEventsAndAddOnMap = function () {

        if (App.Views.TrackEquipmentMaps.equipment && App.Views.TrackEquipmentMaps.equipment.id) {
            var callbackAddEvents = (function (that, events) {
                return function () {
                    that.cleanMarkerEvent(Monet.Session.TrackEquipmentMaps.map);
                    that.addEventsOnMap(Monet.Session.TrackEquipmentMaps.map, events.events, 'TrackEquipmentMaps');
                };

            }(App.Views.TrackEquipmentMaps.events, Monet.Session.TrackEquipmentMaps));
            App.Views.TrackEquipmentMaps.events.requestEvent({ callback: callbackAddEvents });
        }
    };

    this.cleanMarkerEvent = function () {
        if (App.Views.TrackEquipmentMaps.equipment && App.Views.TrackEquipmentMaps.equipment.id) {
            App.Views.TrackEquipmentMaps.events.cleanMarkerEvent(map);
        }
    };


};
